import React from 'react';

const SearchBar = ({ placeholder, searchQuery, setSearchQuery }: any) => {
  return (
    <div className="mb-3 flex items-center gap-2">
      <input
        type="text"
        placeholder={placeholder}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="w-full rounded border px-3 py-1 text-sm outline-gray-300"
      />
      <button onClick={() => setSearchQuery('')} className="rounded bg-gray-200 px-4 py-1 text-sm hover:bg-gray-300">
        Clear
      </button>
    </div>
  );
};

export default SearchBar;
